import { LanguageType } from '@/custom-types';
import { UserGenderTypeOption } from '@/graphql/generated';

export const genderMapper = (gender: UserGenderTypeOption, language: LanguageType) => {
  const optionMap = {
    en: {
      MALE: 'Male',
      FEMALE: 'Female',
      X: 'X',
      OTHER: 'Other'
    },
    es: {
      MALE: 'Masculino',
      FEMALE: 'Femenino',
      X: 'X',
      OTHER: 'Otro'
    }
  }

  return optionMap[language][gender]
}
